import keycloak from 'keycloak-js'

export const instance = keycloak({
  url: 'https://sso.apuscn.com/auth',
  clientId: 'Argus',
  realm: 'LDAP'
})

export const keycloakInit = instance.init({
  checkLoginIframe: false,
  responseMode: 'query',
  onLoad: 'login-required'
  // promiseType: 'native'
})

setInterval(() => {
  instance.updateToken(60)
}, 1000 * 50)
